<template>
  <div v-if="show" class="meet-now-modal">
    <div @click="closeModal" class="meet-now-modal-close close"></div>
    <div   class="meet-now-modal-content">
      <div class="meet-now-modal-content-headline" :class="{'flash': !meetNowStatus && meetNowAvailable}">
        <span>{{headline}}</span>
      </div>
      <div class="meet-now-modal-content-text">
        {{description}}
      </div>
      <div class="meet-now-modal-content-footer">
        <button @click="submit" class="btn  btn-100" :class="{'btn-primary':this.meetNowStatus,'btn-fuchsia':!meetNowStatus && meetNowAvailable, 'btn-gold':!meetNowStatus && !meetNowAvailable}">{{buttonTitle}}</button>
        <p>{{afterButtonText}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex';
import Login from "@buddy/views/new/widgets/Login";
import axios from "axios";

export default {
  components: {
  },
  mixins: [require('@general/lib/mixin').default],
  methods: {
    ...mapActions([
      'changeMeetNowStatus',
    ]),
    closeModal(){
      this.closeMeetNowModal();
    },
    submit(){
      let self = this;
      if(!this.meetNowStatus && !this.meetNowAvailable){
        this.closeModal();
        this.goTo('/profile/pro')
      }else{
        this.changeMeetNowStatus({'action':this.action,'callback':function (){
          }});
        //Close in callback looks not good
        self.closeModal();
      }
    }
  },
  computed: {
      ...mapGetters([
        'meetNowStatus',
        'meetNowAvailable'
      ]),
      headline() {
        if(this.meetNowStatus){
          return this.trans('finished');
        }else{
          if(this.meetNowAvailable){
            return this.trans('meet_now');
          }else{
            return this.trans('over_now')
          }
        }
      },
      afterButtonText(){
        if(!this.meetNowStatus && this.meetNowAvailable) {
          return this.trans('meet_now_mini_text');
        }
      },
      description() {
        if(this.meetNowStatus){
          return this.trans('activate_meet_now_n_times',[window.MEET_NOW_PER_DAY]);
          //return 'Reactivate "NOW!" up to 3 times per day. PRO members may activate without limits.';
        }else{
          if(this.meetNowAvailable) {
            return this.trans('activate_meet_now_n_times',[window.MEET_NOW_PER_DAY]);
          }else{
            return this.trans('meet_now_upgrade_to_pro',[window.MEET_NOW_PER_DAY])
          }
        }
      },
      action(){
        return this.meetNowStatus ? 'disable' : 'enable';
      },
      buttonTitle(){
        if(this.meetNowStatus){
          return this.trans('deactivate_now');
        }else {
          if(this.meetNowAvailable) {
            return this.trans('activate_now');
          }else{
            return this.trans('upgrade_to_pro');
          }
        }
      },
    ...mapState({
      show: state => state.modal.meet_now,
    }),
  },
  data(){
    return {

    }
  },
  mounted() {

  }
}
</script>
